import { Typography } from "@mui/material";
import redBoingo from "../assets/images/boingo_logo_red.png";
import { Box } from "@mui/system";

export default function FaqFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Box className="welcome-footer" sx={{marginTop:"20px"}} data-test-id="welcome-footer">
        <Box className="footLogo">
          <img src={redBoingo} className="boingo-logo-bottom" alt="logo" />
        </Box>
        <Box className="footContent1">
          <Box className="footLinks" data-test-id="welcome-footer-links">
            <a
              target="_blank"
              href="https://www.boingo.com/legal/boingo-privacy-policy/"
              data-test-id="welcome-footer-privacy-link"
            >
              Privacy policy
            </a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a
              target="_blank"
              href="https://www.boingo.com/legal/website-terms-use-acceptable-use-policy/"
              data-test-id="welcome-footer-terms-link"
            >
              Terms of use
            </a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a
              target="_blank"
              href="https://www.boingo.com/legal/cookie-policy/"
              data-test-id="welcome-footer-cookie-link"
            >
              Cookie policy
            </a>
          </Box>
          <Box className="footCopyright" data-test-id="welcome-footer-copyright">
            &copy; {currentYear} Boingo Wireless, Inc. All rights reserved.
          </Box>
        </Box>
      </Box>
    </>
  );
}
